import { useContext, useEffect, useState } from 'react';
import { WorkflowContext } from './ActiveWorkflowsPage';
import { statuses } from './WorkflowDetails';
import { Info } from 'react-feather';
import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import FlexWrapper from '../FlexWrapper';
import ProgressBar from '../../components/Input/ProgressBar';
import StatusToken from '../../components/StatusTokens';
import PulseDot from '../../components/Icons/PulseDot';
import Tooltip from '../../components/popups/Tooltip';
import "./WorkflowInfoBlock.scss";

const WorkflowInfoBlock = ({ header, status, completedTasks, totalTasks, actionName, workflowSummary, onClick, active, clickable, isSelected, timeFrame, publishDate }) => {
	const history = useHistory()
	const { warnings } = useContext(WorkflowContext)
	const { pausedFiles } = useContext(WorkflowContext)
	const [attentionRequired, setAttentionRequired] = useState(0)
	const [filesOnHold, setFilesOnHold] = useState(0)

	useEffect(() => {
		if (header === "Compliance Actions") {
			if (warnings && warnings.length > 0) setAttentionRequired(warnings.length)
			else setAttentionRequired(0)
		}
		if (header === "Data Actions") {
			//console.log("#### WorkflowInfoBlock Paused files: ", pausedFiles)
			setFilesOnHold(pausedFiles)
		}
	}, [warnings, pausedFiles, header])

	const taskIsInProgress = active;

	return (
		<FlexWrapper className={`workflow-info-block-header ${isSelected ? "workflow-info-block-header-active" : ""} ${clickable ? "clickable-info-block" : ""} ${workflowSummary ? "not-disabled" : ""}`} direction="column" align='start' onClick={onClick} >
			<div className={`workflow-info-block-title ${taskIsInProgress ? "workflow-info-block-active" : ""} ${workflowSummary ? "not-disabled" : ""}`} >
				{header}
				{taskIsInProgress && <PulseDot />}
				{attentionRequired !== 0 ? <Tooltip label={"Attention Required (" + attentionRequired + ")"} outerStyle={{ padding: '0.25rem 0 0 0.5rem' }}><Info size={16} className='colour-text-danger'/></Tooltip> : ""}
				{filesOnHold !== 0 ? <Tooltip label={"Files On Hold (" + filesOnHold + ")"} outerStyle={{ padding: '0.25rem 0 0 0.5rem' }}><Info size={16} className='colour-text-danger' onClick={() => history.push(`/data`)}/></Tooltip> : ""}
			</div>
			<FlexWrapper direction="row" className={`workflow-info-block-content`} style={workflowSummary ? { display: "grid", gridTemplateColumns: "100px 170px 140px 180px 180px" } : null}>
				<FlexWrapper direction="column" align='start' className={`workflow-info-block-status-section`}>
					<p>Status</p>
					<div className={`workflow-info-block-detail`}>
						<InfoBlockStatusToken status={status} />
					</div>
				</FlexWrapper>
				<FlexWrapper direction="column" align='start' className={`workflow-info-block-progress-section`}>
					<p>{workflowSummary ? "Total Progress" : "Progress"}</p>
					<div className={`workflow-info-block-detail`}>
						<ProgressBar noToolTip extent={totalTasks} value={completedTasks} colour1={totalTasks === completedTasks ? "#E0FFF6" : null} colour2={totalTasks === completedTasks ? "#56D1C3" : null} />
					</div>
				</FlexWrapper>
				<FlexWrapper direction="column" align='start' className={`workflow-info-block-completion-section`}>
					<p>{actionName}</p>
					<div className={`workflow-info-block-detail`}>
						<h2>{completedTasks}/{totalTasks}</h2>
					</div>
				</FlexWrapper>
				{workflowSummary &&
					<FlexWrapper direction="column" align='start' className={`workflow-info-block-completion-section`}>
						<p>Time Frame</p>
						<div className={`workflow-info-block-detail`}>
							<h2 style={{ textTransform: "capitalize" }}>{timeFrame.toLowerCase()}</h2>
						</div>
					</FlexWrapper>
				}
				{workflowSummary &&
					<FlexWrapper direction="column" align='start' className={`workflow-info-block-completion-section`}>
						<p>Publish Month</p>
						<div className={`workflow-info-block-detail`}>
							<h2 style={{ textTransform: "capitalize" }}>{format(new Date(publishDate), "MMMM")}</h2>
						</div>
					</FlexWrapper>
				}
			</FlexWrapper>
		</FlexWrapper>
	);
}

export const InfoBlockStatusToken = ({ status, style }) => {
	let statusType = '';
	let caseHandledStatus = statuses[status] ? statuses[status] : status;


	switch (caseHandledStatus) {
		case statuses.PENDING:
		case statuses.PENDING_FEEDBACK:
		case statuses.PAUSE:
		case statuses.INACTIVE:
			statusType = 'warning';
			break;
		case statuses.IN_PROGRESS:
			statusType = 'reversed';
			break;
		case statuses.COMPLETED:
		case statuses.COMPLETE:
		case statuses.APPROVED:
		case statuses.READY:
		case statuses.ACTIVE:
			statusType = 'positive';
			break;
		case statuses.ERROR:
		case statuses.INCOMPLETE:
		case statuses.FAILED:
		case statuses.REJECTED:
			statusType = 'danger';
			break;
		default:
			statusType = 'reversed';
	}

	return (
		<StatusToken label={caseHandledStatus ? caseHandledStatus : status ? status : "-"} type={statusType} style={style} />
	)
}

export default WorkflowInfoBlock;